import * as Action from "./ActionTypes";

export const handleState = (payload) =>({
   type: Action.HANDLE_STATE,
   payload: payload
});